import { QuestionmarkSmallCircleFillIcon } from '@zep-us/zus-icons';
import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { Feature } from '@zep/types';
import { Button, Tooltip } from '@zep/ui';
import S from './PricingComparison.module.scss';
import { PricingComparisonColumns } from './PricingComparisonColumns';
export const PricingComparisonRows = (props: PricingComparisonRows) => {
  const {
    features
  } = props;
  const {
    t
  } = useTranslation(['subscription']);
  const userType = 'normal';
  return <>
      {features.filter(({
      type
    }) => !type || type === userType).map((feature, index) => <tr key={feature.name} className={cns({
      [S.odd]: index % 2 === 0
    })}>
            <th scope="row" className={S.tbody_subtitle}>
              <div className={S.feature}>
                <div>
                  <strong>{feature.name}</strong>
                  {feature.isPremiumAppButton && <Button as="a" variant="secondary" size="xs" href={t('subscription:pricing.comparison.premiumAppLink')} target="_blank">
                      {t('subscription:pricing.d50bbd13', '앱 사용 가이드')}
                    </Button>}
                  {feature.isGuideButton && <Button as="a" variant="secondary" size="xs" href={t('subscription:pricing.comparison.detailGuildLink')} target="_blank">
                      {t('subscription:pricing.comparison.detailGuildButtonText')}
                    </Button>}
                </div>
                {feature.tooltip && <Tooltip title={feature.tooltip} tooltipClassName={S.tooltip} placement="top">
                    <QuestionmarkSmallCircleFillIcon width={18} height={18} />
                  </Tooltip>}
              </div>
            </th>

            <PricingComparisonColumns access={feature.access} />
          </tr>)}
    </>;
};
type PricingComparisonRows = {
  features: Feature[];
};